import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { API_URL, HTTP_OPTIONS, ROUTES } from '../constants';
import { Observable } from 'rxjs';
import { IPersonne, IPersonneResponse } from '../models/personne.model';
import { IPersonneTmpResponse } from '../models/personne-tmp.model';

@Injectable({
  providedIn: 'root'
})
export class PersonneService {
  constructor(
    private httpClient: HttpClient,
    private messageService: MessageService
  ) {}
  
  /**
   * Add personne
   * @param body 
   * @returns 
   */
  create(body: IPersonne): Observable<IPersonneResponse> {
    try {
      const response = this.httpClient.post<IPersonneResponse>(`${ROUTES.personne.send}`, body, HTTP_OPTIONS);
      return response;
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Une erreur s\'est produite veuillez contacter le centre pour d\'emple information',
        closable: false,
      });
    }
  }

  /**
   * Get center
   * @returns
   */
  getByMatricule(ref: string): Observable<IPersonneResponse> {
    try {
      const response = this.httpClient.get<IPersonneResponse>(`${ROUTES.personne.oneWithMatricule}/${ref}`, HTTP_OPTIONS);
      return response;
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: error,
        closable: false,
      });
    }
  }

  /**
   * Get center
   * @returns
   */
  getCenter(): Observable<IPersonneTmpResponse> {
    return this.httpClient.get<IPersonneTmpResponse>(`${ROUTES.personne.one}`);
  }

  getCenter2(): Observable<IPersonneResponse> {
    return this.httpClient.get<IPersonneResponse>(`${ROUTES.personne.cace}`);
  }

}
